import React from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { HideableTextFormField } from '../../../components/FormCom/HideableTextFormField';
import { HideableTextWithOutErrorMsgFormField } from '../../../components/FormCom/HideableTextWithOutErrorMsgFormField';
import PasswordStrengthViewer from '../../../components/FormCom/PasswordStrengthIndicator';
import useResetPassword from '../../../hooks/auth/admin/useResetPassword';
import {
  ChangePasswordOnSignInDataType,
  changePasswordOnSignInInitialValues,
  ChangePasswordOnSignInSchema,
} from '../../../models/auth/changePassword';
import { ACCOUNT, CHANGE_PASSWORD_VERIFICATION_CONFIRMATION } from '../../../routes/routeConstants';
import ChangePasswordWrapper from './ChangePasswordWrapper';

const ChangePassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loading, resetPassword } = useResetPassword();
  const token = searchParams.get('token');

  const onSubmit = (value: ChangePasswordOnSignInDataType) => {
    resetPassword({ ...value, token: token ?? '' }, () => {
      navigate(`/${ACCOUNT}/${CHANGE_PASSWORD_VERIFICATION_CONFIRMATION}`, {
        replace: true,
      });
    });
  };

  return (
    <Container>
      <ChangePasswordWrapper
        formHeaderTitle='Reset Your Password'
        formHeaderDescription='Create a new password to login to your Logirate account.'
      >
        <FormComponent
          initialValues={changePasswordOnSignInInitialValues}
          schema={ChangePasswordOnSignInSchema}
          onSubmit={onSubmit}
        >
          <HideableTextWithOutErrorMsgFormField
            label='Password'
            name='newPassword'
            type='password'
            id='newPassword'
            placeholder='Password'
          />

          <PasswordStrengthViewer passwordName='newPassword' />

          <HideableTextFormField
            label='Confirm Password'
            name='confirmPassword'
            type='password'
            id='confirmPassword'
            placeholder='Confirm Password'
          />

          <FormSubmitButton loading={loading} className='topMargin large'>
            Reset
          </FormSubmitButton>
        </FormComponent>
      </ChangePasswordWrapper>
    </Container>
  );
};

export default ChangePassword;

const Container = styled.div`
  display: flex;
  height: 100vh;
  color: ${({ theme }) => theme.palette.grayTextColor};
  background-color: ${({ theme }) => theme.palette.lightSignInBg};

  align-items: center;
  justify-content: center;
`;
